import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { CheckCircle2, Loader2 } from "lucide-react";

export default function SubscribeSuccessPage() {
  const [params] = useSearchParams();
  const { refresh } = useAuth();
  const [state, setState] = useState("loading"); // loading | success | failed
  const sessionId = params.get("session_id");
  const comped = params.get("comped");

  useEffect(() => {
    if (comped === "1") { setState("success"); refresh(); return; }
    if (!sessionId) { setState("failed"); return; }
    let attempts = 0;
    const poll = async () => {
      attempts += 1;
      try {
        const { data } = await api.get(`/checkout/status/${sessionId}`);
        if (data.payment_status === "paid") {
          await refresh();
          setState("success");
          return;
        }
        if (data.status === "expired") { setState("failed"); return; }
      } catch {}
      if (attempts < 10) setTimeout(poll, 2000);
      else setState("failed");
    };
    poll();
  }, [sessionId, comped, refresh]);

  return (
    <div className="max-w-2xl mx-auto px-6 py-24 text-center fade-up" data-testid="subscribe-success-page">
      {state === "loading" && (
        <>
          <Loader2 className="w-10 h-10 mx-auto text-[#0A0A0A] animate-spin" strokeWidth={1.5} />
          <div className="font-mono uppercase tracking-widest text-xs text-[#525252] mt-6">Verifying payment…</div>
        </>
      )}
      {state === "success" && (
        <>
          <div className="w-16 h-16 mx-auto rounded-full bg-[#E8DFC1] border border-[#0A0A0A]/30 flex items-center justify-center">
            <CheckCircle2 className="w-7 h-7 text-[#0A0A0A]" strokeWidth={1.5} />
          </div>
          <h1 className="font-heading text-5xl text-[#0A0A0A] mt-8 tracking-tight">Welcome to Reads+</h1>
          <p className="text-[#525252] mt-4">You now have unlimited book additions and unlimited personalised recommendations.</p>
          <div className="mt-10 flex flex-wrap gap-3 justify-center">
            <Link to="/discover" className="bg-[#0A0A0A] hover:bg-[#1F1F1F] text-white font-mono uppercase tracking-widest text-xs px-6 py-3 rounded-sm transition-colors" data-testid="success-discover">Browse library →</Link>
            <Link to="/account" className="border border-[rgba(0,0,0,0.18)] text-[#0A0A0A] font-mono uppercase tracking-widest text-xs px-6 py-3 rounded-sm hover:bg-black/5 transition-colors" data-testid="success-account">View account</Link>
          </div>
        </>
      )}
      {state === "failed" && (
        <>
          <div className="font-heading text-3xl text-[#0A0A0A]">Couldn't confirm your payment</div>
          <p className="text-[#525252] mt-4">If you completed checkout, give it a minute and refresh. Otherwise try again.</p>
          <Link to="/subscribe" className="inline-block mt-8 font-mono uppercase tracking-widest text-xs text-[#0A0A0A] hover:underline" data-testid="retry-link">Back to Reads+ →</Link>
        </>
      )}
    </div>
  );
}
